import { SearchFavoriteResult } from '@domain/types';
import { Http } from '@services/http';

const DIRECTORY_PATH = '/directory';

export async function searchIdentityFavorites(searchParams: {
  identityReference: string;
  type: 'directory' | 'directory_contact';
  searchText?: string;
  source?: 'ai' | 'user';
  page: number;
}): Promise<SearchFavoriteResult> {
  return await Http.getInstance().get({
    path: `${DIRECTORY_PATH}/identity_favorites`,
    searchParams,
  });
}

export async function deleteIdentityFavorite(
  identityReference: string,
  payload: {
    recipientReference?: string;
    directoryContactId?: string | number;
  },
): Promise<null> {
  return await Http.getInstance().destroyWithBody({
    path: `${DIRECTORY_PATH}/identity_favorites/identity_favorite`,
    body: { identityFavorite: { identityReference, ...payload } },
  });
}

export async function createIdentityFavorite(
  identityReference: string,
  payload: {
    recipientReference?: string;
    directoryContactId?: string | number;
  },
): Promise<null> {
  return await Http.getInstance().post({
    path: `${DIRECTORY_PATH}/identity_favorites`,
    body: { identityFavorite: { identityReference, ...payload } },
  });
}
